var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaximize = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 4.44772 4.44772 4 5 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H6V11C6 11.5523 5.55229 12 5 12C4.44772 12 4 11.5523 4 11V5Z",
    fill: "#0D0F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 28C4.44772 28 4 27.5523 4 27L4 21C4 20.4477 4.44772 20 5 20C5.55228 20 6 20.4477 6 21L6 26H11C11.5523 26 12 26.4477 12 27C12 27.5523 11.5523 28 11 28H5Z",
    fill: "#0D0F13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7071 4.29289C27.8946 4.48043 28 4.73478 28 5V11C28 11.5523 27.5523 12 27 12C26.4477 12 26 11.5523 26 11V6H21C20.4477 6 20 5.55228 20 5C20 4.44772 20.4477 4 21 4L27 4C27.2652 4 27.5196 4.10536 27.7071 4.29289Z",
    fill: "#0D0F13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7071 27.7071C27.5196 27.8946 27.2652 28 27 28H21C20.4477 28 20 27.5523 20 27C20 26.4477 20.4477 26 21 26H26V21C26 20.4477 26.4477 20 27 20C27.5523 20 28 20.4477 28 21V27C28 27.2652 27.8946 27.5196 27.7071 27.7071Z",
    fill: "#0D0F13"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaximize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maximize.4b14c0dc0de8ca5c3d23672121d48f00.svg";